module.exports = __webpack_public_path__ + "img/passenger.7e572511.png";